import { ComponentProps } from "react"
import { tv, VariantProps } from "tailwind-variants"

type Props = ComponentProps<"select"> & {
  options: { label: string; value: string }[]
  placeholder?: string
} & VariantProps<typeof inputStyles>

const inputStyles = tv({
  base: [
    "appearance-none rounded-none",
    "flex items-center transition-colors duration-200 px-2 py-0 type-ui-m-light h-button",
    "field-stretch",
    "bg-white text-black border-b border-solid border-black",
    "hover:bg-grey-light",
    "placeholder:text-black/50 autofill:bg-[#FFF6DF]",
    "error:text-error-dark error:placeholder:text-error-dark error:bg-error-light error:hover:bg-grey-light error:border-error-dark",
    "disabled:border-grey-light disabled:text-grey-light disabled:bg-white disabled:placeholder:text-grey-light",
  ],
  variants: {
    large: {
      true: "p-3 h-buttonLg resize-none",
    },
    error: {
      true: "error",
    },
  },
})

export function SimpleSelect({ large, error, ...props }: Props) {
  const styles = inputStyles({ large, error })
  return (
    <select className={styles} {...props}>
      {props.placeholder !== undefined ? <option value="">{props.placeholder ?? ""}</option> : null}
      {props.options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}
